/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InboundDocument } from './InboundDocument';
import {
    InboundDocumentFromJSON,
    InboundDocumentFromJSONTyped,
    InboundDocumentToJSON,
    InboundDocumentToJSONTyped,
} from './InboundDocument';

/**
 * 
 * @export
 * @interface SplitInboundDocument201Response
 */
export interface SplitInboundDocument201Response {
    /**
     * 
     */
    data: Array<InboundDocument>;
}

/**
 * Check if a given object implements the SplitInboundDocument201Response interface.
 */
export function instanceOfSplitInboundDocument201Response(value: object): value is SplitInboundDocument201Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function SplitInboundDocument201ResponseFromJSON(json: any): SplitInboundDocument201Response {
    return SplitInboundDocument201ResponseFromJSONTyped(json, false);
}

export function SplitInboundDocument201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SplitInboundDocument201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(InboundDocumentFromJSON)),
    };
}

export function SplitInboundDocument201ResponseToJSON(json: any): SplitInboundDocument201Response {
    return SplitInboundDocument201ResponseToJSONTyped(json, false);
}

export function SplitInboundDocument201ResponseToJSONTyped(value?: SplitInboundDocument201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(InboundDocumentToJSON)),
    };
}

